import React from 'react';
import PropTypes from 'prop-types';

import AddToCartBtn from '../AddToCartBtn/AddToCartBtn';
import Image from '../Image';

import { StyledImageWrapper, StyledInfoWrapper, StyledTitle } from '../CollectionCard/CollectionCardStyles';
import { StyledPriceWrapper, StyledPriceCrossedOut } from '../CollectionCardPrice/CollectionCardPriceStyles';
import { StyledWrapper, StyledButtonWrapper } from './DyCollectionCardStyles';

var DyCollectionCard = function DyCollectionCard(props) {
  // make href relative
  var productHref = props.product.urlWithProtocol.replace('https://www.dormify.com', '');
  var getCroppedImage = function getCroppedImage(image_url) {
    return image_url.replace('.jpg', '_600x600_crop_center.jpg');
  };

  return React.createElement(
    StyledWrapper,
    {
      'data-dy-product-id': props.product.sku,
      'data-dy-strategy-id': props.product.strId,
      isAddOnModal: props.isAddOnModal
    },
    React.createElement(
      StyledImageWrapper,
      { href: productHref },
      props.product.image_url ? React.createElement(Image, {
        src: getCroppedImage(props.product.image_url),
        alt: props.product.name
      }) : null
    ),
    React.createElement(
      StyledButtonWrapper,
      null,
      React.createElement(AddToCartBtn, {
        addVariantToCart: props.addVariantToCart,
        product: props.product,
        variantExists: true,
        selectedVariantAvailable: true,
        selectedVariantId: props.product.selectedVariantId,
        selectedVariantQuantity: 1,
        btnStyle: 'COLLECTION',
        ineligibleForDiscount: props.product.tags.includes('data--no_coupon:1')
      })
    ),
    React.createElement(
      StyledInfoWrapper,
      null,
      React.createElement(
        StyledTitle,
        { href: productHref },
        props.product.name
      ),
      React.createElement(
        StyledPriceWrapper,
        null,
        React.createElement(
          'span',
          null,
          '$',
          props.product.dy_display_price.replace('.00', '')
        ),
        props.product.in_sale && React.createElement(
          StyledPriceCrossedOut,
          null,
          '$',
          props.product.in_sale.replace('.00', '')
        )
      )
    )
  );
};

DyCollectionCard.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  collectionTitle: PropTypes.string,
  isAddOnModal: PropTypes.bool
};

export default DyCollectionCard;